(function(){
  function r(){
    document.querySelectorAll("a,span,div,li").forEach(e=>{
      const t=e.textContent.trim();
      if(t==="catalog") e.textContent="catalogue";
      else if(t==="Catalog") e.textContent="Catalogue";
      else if(t==="CATALOG") e.textContent="CATALOGUE";
    });
  }
  r();
  new MutationObserver(r).observe(document.body,{childList:true,subtree:true});
})();
